import { useParams, useSearchParams } from 'react-router-dom';
import { useAccountParam } from 'hooks';

export type InvoiceParams = {
    accountId: string,
    vendorId: string,
    invoiceId: string,
    voucherId?: string,
    adjustmentIdentityKey?: string,
};

export default function useInvoiceParams() : InvoiceParams {
    const accountId = useAccountParam();
    const { vendorId = '', invoiceId = '' } = useParams() as Partial<InvoiceParams>;
    const [searchParams] = useSearchParams();
    const voucherId = searchParams.get('voucherId') || undefined;
    const adjustmentIdentityKey = searchParams.get('adjustmentIdentityKey') || undefined;
    return { accountId, vendorId, invoiceId, voucherId, adjustmentIdentityKey };
};
